<ob-alert type="info" style="font-size: 1rem;">
    <div [innerHTML]="content"></div>
    <p style="margin-top: 5px">
      <span class="ob-nav-link" (click)="exportDataSheet()" role="button" tabindex="0">
        <mat-icon svgIcon="file_excel" class="ob-icon remove-whitespace"></mat-icon>
        <span class="link-text" translate>i18n.result.download.exportAnalyse.excel-datei</span>
      </span>
    </p>
</ob-alert>
